import React, { Component } from "react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { ActivityIndicator, VStack } from "IZOX/_X";
import MainSlide from "./_gears/MainSlide";
import { observer } from "mobx-react";
import AboutUs from "./_gears/AboutUs";
import DescSlide from "./_gears/DescSlide";
import Compen from "./_gears/Compen";
import ServiceDesc from "./_gears/ServiceDesc";
import GInsure from "./_gears/GInsure";
import Partner from "./_gears/Partner";
import ContactInfo from "./_gears/ContactInfo";
import PageNav from "./_gears/PageNav";
import MapForm from "./_gears/MapForm";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import XAnchor from "IZOX/_X/XAnchor";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import _ from "lodash";
import Funcs from "__SYSDefault/Funcs";
import FooterM from "shared/FooterM";
import { SysConfig } from "__SYSDefault/Config";
import PricingPlan from "./_gears/PricingPlan";

/**
 * @augments {Component<Props, State>}
 */
class PIndex extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      ready: false
    };
  }

  componentDidMount(){
    this._GetInfo();
    this._setAllStates(() => {
      let {location} = this.props;
      if(!_.isEmpty(location?.hash)){
        setTimeout(() => {
          this._toAnchor(location?.hash);
        }, 100);
      }
    });
    document.addEventListener("wheel", this.updateScroll);
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PIndex.defaultProps))){
      this._setAllStates(() => {
        let {location} = this.props;
        if(!_.isEmpty(location?.hash)){
          setTimeout(() => {
            this._toAnchor(location?.hash);
          }, 100);
        }
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("wheel", this.updateScroll);
    this.setState = (state, callback) => {
      return;
    };
  }

  updateScroll = () => {
    let top = this.scrollRef?.getBoundingClientRect?.()?.top;
    Funcs.SetIndexScroll(top ?? 0);
    Funcs.SetMenuClick("");
  }

  _GetInfo = async () => {
    let info = await APIExpress.WebSettings.GetInfo();
    this.setState({
      info: info,
      ready: true
    });
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  onMountAnchorAboutUS = (callbacks) => {
    this.MountAnchorAboutUS = callbacks;
  }

  onMountAnchorServices = (callbacks) => {
    this.MountAnchorServices = callbacks;
  }

  _toAnchor = (hash) => {
    console.log("_toAnchor");
    switch(hash){
      case "#aboutus":
        this.MountAnchorAboutUS?.ScrollIntoView?.(150);
        break;
      case "#services": 
        this.MountAnchorServices?.ScrollIntoView?.(150);
        break;
      default: break;
    }
  }

  renderNormal(){
    let {info} = this.state;
    let {history} = this.props;
    return (
      <VStack fullWidth>
        <MainSlide history={history} info={info}/>
        <VStack mT={-160} fullWidth forwardRef={e => this.scrollRef = e}
          style={{overflowY: "scroll"}}>
          <XAnchor onMounted={this.onMountAnchorAboutUS} scrollRef={this.scrollRef}/>
          <AboutUs info={info}/>
          <DescSlide info={info}/>
          <Compen info={info}/>
          <PricingPlan info={info}/>
          <XAnchor onMounted={this.onMountAnchorServices} scrollRef={this.scrollRef}/>
          <ServiceDesc info={info}/>
          <GInsure history={history} info={info}/>
          <MapForm info={info}/>
          <Partner/>
          <ContactInfo info={info}/> 
          <PageNav history={history} info={info}/>
        </VStack>
      </VStack>
    );
  }

  renderMobile(){
    let {info} = this.state;
    let {history} = this.props;
    return (
      <VStack fullWidth>
        <MainSlide history={history} info={info}/>
        <VStack mT={-160} fullWidth forwardRef={e => this.scrollRef = e}
          style={{overflowY: "scroll"}}>
          <XAnchor onMounted={this.onMountAnchorAboutUS} scrollRef={this.scrollRef}/>
          <AboutUs info={info}/>
          <DescSlide info={info}/>
          <Compen info={info}/>
          <PricingPlan info={info}/>
          <XAnchor onMounted={this.onMountAnchorServices} scrollRef={this.scrollRef}/>
          <ServiceDesc info={info}/>
          <GInsure history={history} info={info}/>
          <MapForm info={info}/>
          <Partner/>
          <ContactInfo info={info}/> 
          <PageNav history={history} info={info}/>
          <FooterM/>
        </VStack>
      </VStack>
    );
  }

  render(){
    let {ready} = this.state;
    if(!ready){
      return (
        <VStack fullWidth fullHeight VAlign="-" HAlign="|">
          <ActivityIndicator loading size={Math.min(100, window.innerWidth * 0.5)} thickness={10}/>
        </VStack>
      );
    }
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default withRouter(observer(PIndex));
